require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-verifiable-bookmarklets.json") })
        }
      }, "path---projects-verifiable-bookmarklets");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-verifiable-bookmarklets!./.cache/json/projects-verifiable-bookmarklets.json
// module id = 289
// module chunks = 231608221292675